import { useEffect, useState } from "react";
import { getCrewMemberPhoto, deleteCrewMemberPhoto } from "../../apis/crewImage";
import { Button, message } from "antd";

const ImagePreview = ({ employeePhotoId, onImageUpdated }) => {
  const [imageSrc, setImageSrc] = useState(null);
  const [loading, setLoading] = useState(false);
  const photoId = employeePhotoId?.employeePhotos?.[0]?.employeePhotoId;

  useEffect(() => {
    if (!photoId) return;

    const fetchImage = async () => {
      try {
        const res = await getCrewMemberPhoto({ employeePhotoId: photoId });
        const blob = new Blob([res], { type: "image/jpeg" });
        const imageUrl = URL.createObjectURL(blob);
        setImageSrc(imageUrl);
      } catch (error) {
        console.error("Failed to fetch image", error);
      }
    };

    fetchImage();
  }, [photoId]);

  const handleDelete = async () => {
    if (!photoId) return;

    try {
      setLoading(true);
      await deleteCrewMemberPhoto({employeeId: employeePhotoId?.employeeId});
      setImageSrc(null);
      message.success("Image deleted successfully");
      onImageUpdated();
    } catch (error) {
      message.error("Failed to delete image");
    } finally {
      setLoading(false);
    }
  };

  if (!photoId || !imageSrc) {
    return <p style={{ textAlign: "center", color: "gray" }}>No Image Available</p>;
  }

  return (
    <div style={{ textAlign: "center" }}>
      <img
        src={imageSrc}
        alt="Employee"
        style={{ width: "200px", height: "300px", objectFit: "cover", borderRadius: "8px" }}
      />
      <div style={{ marginTop: "10px" }}>
        <Button danger onClick={handleDelete} loading={loading}>
          Delete Image
        </Button>
      </div>
    </div>
  );
};

export default ImagePreview;
